import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Layout from "./hocs/Layout";
import AuthPage from "./containers/AuthPage/AuthPage";
import PrivateRoute from "./components/PrivateRoute";
import Services from "./containers/Services/Services";

import CounterPartyIssues from "./containers/CounterPartyIssues/CounterPartyIssues/CounterPartyIssues";
import CounterPartyIssueDetails from "./containers/CounterPartyIssues/CounterPartyIssues/CounterPartyIssueDetails";
import ReportedIssues from "./containers/ReportedIssues/ReportedIssues/ReportedIssues";
import ReportedIssueDetails from "./containers/ReportedIssues/ReportedIssues/ReportedIssueDetails";
import { ContactUs } from "./containers/ContactUs/ContactUs";
import Faqs from "./containers/Faqs/Faqs";
import Analytics from "./containers/Analytics/Analytics";
import Orders from "./containers/Orders/Orders";
import OrderDetails from "./containers/Orders/OrderDetails";
import Settlements from "./containers/Settlements/Settlements";
import SettlementDetails from "./containers/Settlements/SettlementDetails";
import MiscSettlement from "./containers/MiscSettlement/MiscSettlement";
import MiscSettlementDetails from "./containers/MiscSettlement/MiscSettlementDetails";
import Reports from "./containers/Reports/Reports";
import Recons from "./containers/Recons/Recons";
import ReconDetails from "./containers/Recons/ReconDetails";
import CatalogueRejections from "./containers/CatalogueRejection/CatalogueRejection";
import CatalogueDetails from "./containers/CatalogueRejection/CatalogueDetails";
import StoreView from "./containers/StoreView/StoreView";
import IgmDashboard from "./containers/IgmDashboard/IgmDashboard";
import RsfDashboard from "./containers/RsfDashboard/RsfDashboard";
import Payout from "./containers/Payout/Payout";

function App() {
  const { authData, raiseIssue, attribute } = useSelector(
    (state) => state.loginSlice
  );
  //console.log(raiseIssue);
  //console.log(attribute);

  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route element={<PrivateRoute />}>
        <Route path="/services" element={<Services />} />

        <Route element={<Layout />}>
          <Route path="/" element={<Analytics />} />
          <Route path="/IgmDash" element={<IgmDashboard />} />
          <Route path="/RsfDash" element={<RsfDashboard />} />
          <Route path="/payout" element={<Payout/>} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderDetails />} />

          <Route path="/issues/buyer" element={<CounterPartyIssues />} />
          <Route
            path="/issues/buyer/:issueId"
            element={<CounterPartyIssueDetails />}
          />
          <Route path="/issues/seller" element={<ReportedIssues />} />
          <Route
            path="/issues/seller/:issueId"
            element={<ReportedIssueDetails />}
          />
          <Route path="/settlement" element={<Settlements />} />
          <Route
            path="/settlements-detail/:settlementId"
            S
            element={<SettlementDetails />}
          />
          <Route path="/recons" element={<Recons />} />
          <Route path="/recons-detail/:reconId" element={<ReconDetails />} />
          <Route path="/misc-settlements" element={<MiscSettlement />} />
          <Route
            path="/misc-settlements-detail/:settlementId"
            element={<MiscSettlementDetails />}
          />

          <Route path="/reports" element={<Reports />} />
          <Route
            path="/catalogue-rejection"
            element={<CatalogueRejections />}
          />
          <Route
            path="/catalogue-rejection/:id"
            element={<CatalogueDetails />}
          />

          <Route path="/store-settings" element={<StoreView />} />

          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faq" element={<Faqs />} />
        </Route>
      </Route>

      <Route
        path="*"
        element={<Navigate to={authData ? "/" : "/login"} replace />}
      />

      {/* <Route
        path="*"
        element={<Navigate to={authData ? "/orders" : "/login"} replace />}
      /> */}
    </Routes>
  );
}

export default App;
